import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { PointingSystemRoutingModule } from './pointing-system-routing.module'
import { CustomizePointsComponent } from './pages/customize-points/customize-points.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { PointsHistoryListComponent } from './pages/points-history-list/points-history-list.component'
import { PointsHistoryTableComponent } from './components/points-history-table/points-history-table.component'
import { PointsStatisticsComponent } from './pages/points-statistics/points-statistics.component'
import { NgApexchartsModule } from 'ng-apexcharts'
import { PointsFilterComponent } from './components/points-filter/points-filter.component'
import { MatMomentDateModule } from '@angular/material-moment-adapter'

@NgModule({
	declarations: [
		CustomizePointsComponent,
		PointsHistoryListComponent,
		PointsHistoryTableComponent,
		PointsStatisticsComponent,
		PointsFilterComponent,
	],
	imports: [
		CommonModule,
		PointingSystemRoutingModule,
		SharedModule,
		NgApexchartsModule,
	],
})
export class PointingSystemModule {}
